import dayjs from 'dayjs'

export type CostFormValues = {
  amount: number
  type: string | ''
  description: string
  quantity: string
  startDate: dayjs.Dayjs | null
  endDate: dayjs.Dayjs | null
  principal: string
  monthRepeat?: boolean
  monthRepeatAmount?: string
  currentMonthRepeatNumber?: string
  projectId: string | null
}

export const defaultCostFormValues: CostFormValues = {
  amount: 1,
  type: '',
  description: '',
  quantity: '1',
  startDate: null,
  endDate: null,
  principal: '',
  monthRepeat: false,
  monthRepeatAmount: '',
  currentMonthRepeatNumber: '',
  projectId: null,
}
